import React from 'react'
import { isInvestor } from '../../../../global/authentication/authentication-manager.js'

function OverviewNewNoteworthy({ newNoteWorthy }) {
  let cardCount = (newNoteWorthy.match(/u-size4of12/g) || []).length
  let investorHideCount = (newNoteWorthy.match(/hide-from-investor/g) || [])
    .length
  let hideNewNoteworthy = isInvestor() && cardCount === investorHideCount

  if (newNoteWorthy && !hideNewNoteworthy) {
    return (
      <div id="new-noteworthy" className="u-paddingVert6gu">
        <h3 className="u-marginBottom6gu">New and Noteworthy</h3>
        <div dangerouslySetInnerHTML={{ __html: newNoteWorthy }} />
      </div>
    )
  } else {
    return null
  }
}

export default OverviewNewNoteworthy
